import { render } from "./DraftsContent.vue?vue&type=template&id=62488b7c"
import script from "./DraftsContent.vue?vue&type=script&lang=js"
export * from "./DraftsContent.vue?vue&type=script&lang=js"

import "./DraftsContent.vue?vue&type=style&index=0&id=62488b7c&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__